<template>
    <div class="is-flex">
        <div class="text-column">
            <editor-js
                :data="data.columns[0].content"
                @save="(d) => save(0, d)"
            />
        </div>
        <div class="text-column">
            <editor-js
                :data="data.columns[1].content"
                @save="(d) => save(1, d)"
            />
        </div>
    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";

    export default {
        components: {EditorJs},
        props: ['data'],
        methods: {
            save(column, data) {
                this.data.columns[column].content = data;
            }
        },
        created() {
            if (!this.data.columns) {
                this.data.columns = [
                    {column: 1, content: null, attributes: {}},
                    {column: 2, content: null, attributes: {}}
                ];
            }
        }
    };
</script>

<style scoped lang="scss">
    .text-column {
        position: relative;
        flex: 1 1 50%;
    }
</style>
